<script setup lang="ts">
type SurveyEvaluateItem = {
  code: string
  name: string
  route: string
  order?: number
  level?: number
  setting?: string
}

/** 组件入参，控制筛选项数据和当前激活路由。 */
const props = withDefaults(
  defineProps<{
    list?: SurveyEvaluateItem[]
    activeRoute?: string
  }>(),
  {
    list: () => [],
    activeRoute: 'all',
  },
)

const { localePath } = useAppI18n()

/** 过滤掉无效项并按后端 order 保持展示顺序。 */
const visibleList = computed(() =>
  [...props.list]
    .filter((item) => item?.route && item?.name)
    .sort((left, right) => (left.order ?? 0) - (right.order ?? 0)),
)

/** 判断当前 tab 是否为激活态。 */
const isActiveItem = (item: SurveyEvaluateItem) => item.route === props.activeRoute
</script>

<template>
  <div
    v-if="visibleList.length"
    class="flex w-full items-center gap-[24px] border-b-[0.5px] border-[rgba(5,21,36,0.06)] pt-[16px]"
  >
    <NuxtLink
      v-for="item in visibleList"
      :key="item.code"
      :to="
        localePath({
          name: 'inspections-category',
          params: {
            category: item.route,
          },
        })
      "
      class="flex shrink-0 cursor-pointer flex-col items-center justify-between px-[0px] text-center"
      :class="isActiveItem(item) ? 'h-[44px] pb-[0px]' : 'justify-center pb-[16px]'"
    >
      <span
        class="text-center text-[20px] leading-[28px] whitespace-nowrap"
        :class="isActiveItem(item) ? 'font-[600] text-[#292a2e]' : 'font-[400] text-[#8c8f97]'"
      >
        {{ item.name }}
      </span>

      <span v-if="isActiveItem(item)" class="mt-[12px] h-[4px] w-[28px] rounded-[999px] bg-[#292a2e]" />
    </NuxtLink>
  </div>
</template>
